import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a8c01f2061e270014db3a25_1787582062594_19075d03/eaclegal/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a8c01f2061e270014db3a25_1787582062594_19075d03/eaclegal/src/components/Header.tsx");
